/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Grid, IconButton, Box } from '@material-ui/core'
import axios from 'axios'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch, useSelector } from 'react-redux'
import Icon from '@mdi/react'
import { mdiInvoiceTextCheckOutline } from '@mdi/js'

import { SNACKBAR } from '../../../main/MainActions'
import colors from '../../../../assets/colors'
import config from '../../../../config'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { isCpfCnpjValid } from '../../../../util/cpf_cnpj_validator'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import { fetchAttendanceInit, getNfseCompanies } from '../../AttendanceActions'
import {
  show,
  indexNfseEnquadramento,
  indexNfsenEnquadramento,
  storeNfseEnquadramento,
  storeNfsenEnquadramento,
} from '../../../laundry-eletronic-invoice/LaundryEletronicInvoiceActions'
import EnquadramentoFormModal from '../../../laundry-eletronic-invoice/pages/Forms/Enquadramentos/FormModal'
import {
  NFSE_ENQUADRAMENTO_FIELDS,
  NFSEN_ENQUADRAMENTO_FIELDS,
} from '../../../laundry-eletronic-invoice/pages/Forms/Enquadramentos/fields'

import useStyles from './styles'
import { Forms } from './Form'

const EletronicInvoice = props => {
  const classes = useStyles()

  const history = useHistory()
  const dispatch = useDispatch()
  const filterClasses = filterStylesComponents()

  const nfseCompanies = useSelector(state => state.attendance.nfseCompanies)

  const [attendance, setAttendance] = useState()
  const [nfseError, setNfseError] = useState()
  const [enquadramentos, setEnquadramentos] = useState([])
  const [isNational, setIsNational] = useState(false)
  const [enquadramentoModalOpen, setEnquadramentoModalOpen] = useState(false)

  const [loading, setLoading] = useState(false)

  const { id } = props.match.params

  const [mask, setMask] = useState('999.999.999-99')

  const [form, setForm] = useState({
    description: '',
    value: '',
    cpf_cnpj: '',
    client_name: '',
    client_cep: '',
    client_city: '',
    client_uf: '',
    client_street: '',
    client_neighborhood: '',
    client_number: '',
    client_complement: '',
    client_phone: '',
    client_email: '',
    iss_retido: '',
    aliquota_iss: '',
    enquadramento_id: '',
    // Padrão Nacional (NFSen) — ignorados no envio quando o tenant é Municipal
    tributacao_iss: 1, // 1 = Operação tributável (default)
    tipo_retencao_iss: 1, // 1 = Não retido (default)
  })

  const [cpfCnpj, setCpfCnpj] = useState({
    error: false,
    text: '',
  })

  const fetchAttedance = async () => {
    try {
      const resp = await axios.get(`${config.API_URL}/attendance/${id}`)

      setAttendance(resp?.data?.data)
    } catch (e) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: {
          message: e?.response?.data?.message,
        },
      })
    }
  }

  const handleChange = e => {
    e.preventDefault()

    const { name, value } = e.target

    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleEnquadramentoChange = e => {
    const { value } = e.target
    const selected = enquadramentos?.find(item => item?.id == value)

    setForm(prev => ({
      ...prev,
      enquadramento_id: value,
      aliquota_iss:
        selected?.aliquota_iss != null ? String(selected.aliquota_iss) : '',
    }))
  }

  const handleInitDescription = () => {
    const { services } = attendance

    if (Array.isArray(services)) {
      const { client } = attendance
      let servicesDescription = ''

      services?.map(serviceItem => {
        servicesDescription += `- ${serviceItem?.name} ${' '}`
      })

      setForm({
        ...form,
        description: servicesDescription,
        value: attendance?.total_with_discount,
        cpf_cnpj: client?.cpf_cnpj,
        client_name: client?.name,
        client_city: client?.city,
        client_uf: client?.uf,
        client_street: client?.street,
        client_neighborhood: client?.neighborhood,
        client_number: client?.number,
        client_cep: client?.cep,
        client_complement: client?.complement,
        client_phone: client?.phone,
        client_email: client?.email,
      })

      if (client?.cpf_cnpj?.length >= 15) {
        setMask('99.999.999/9999-99')
      } else {
        setMask('999.999.999-999')
      }
    }
  }

  const handleChangeCpf = e => {
    const { name, value } = e.target

    if (value.length >= 15) {
      setMask('99.999.999/9999-99')
    } else {
      setMask('999.999.999-999')
    }

    setForm({
      ...form,
      [name]: value,
    })
  }

  const handlePasteCpf = e => {
    const digits = e.clipboardData.getData('text').replace(/[^\d]/g, '')
    if (digits.length > 11) {
      e.preventDefault()
      setMask('99.999.999/9999-99')
      const cnpj = digits
        .slice(0, 14)
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      setForm({ ...form, cpf_cnpj: cnpj })
    }
  }

  const handleValidCpfCnpj = e => {
    const { name, value } = e.target

    if (value.length == 14) {
      if (isCpfCnpjValid(value)) {
        setCpfCnpj({
          ...cpfCnpj,
          error: false,
          text: '',
        })
      } else {
        setCpfCnpj({
          ...cpfCnpj,
          error: true,
          text: 'CPF inválido',
        })
      }
    } else if (value.length == 18) {
      if (isCpfCnpjValid(value)) {
        setCpfCnpj({
          ...cpfCnpj,
          error: false,
          text: '',
        })
      } else {
        setCpfCnpj({
          ...cpfCnpj,
          error: true,
          text: 'CNPJ inválido',
        })
      }
    } else {
      setCpfCnpj({
        ...cpfCnpj,
        error: false,
        text: 'Digite um CPF ou CNPJ válido',
      })
    }
  }

  const handleSearchCep = async cep => {
    const currentCep = cep?.replace(/\D/g, '')

    try {
      if (currentCep?.length == 8) {
        const resp = await axios
          .get(`https://viacep.com.br/ws/${currentCep}/json/`)
          .then(response => response?.data)

        setForm({
          ...form,
          client_city: resp?.localidade,
          client_uf: resp?.uf,
          client_street: resp?.logradouro,
          client_neighborhood: resp?.bairro,
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // Monta o payload conforme o padrão da NFSe do tenant.
  // Nacional (NFSen): situação tributária e retenção do ISSQN vão por nota
  // (tributacao_iss + tipo_retencao_iss); iss_retido não é enviado.
  // Municipal: mantém iss_retido como antes.
  const buildPayload = () => {
    const {
      iss_retido,
      tributacao_iss,
      tipo_retencao_iss,
      aliquota_iss,
      ...rest
    } = form

    if (isNational) {
      const payload = {
        ...rest,
        tributacao_iss,
        tipo_retencao_iss,
      }

      // Alíquota só é usada na operação tributável (1); nas demais o backend ignora.
      // Se vazia, o backend usa a alíquota do enquadramento.
      if (tributacao_iss == 1 && aliquota_iss !== '' && aliquota_iss != null) {
        payload.aliquota_iss = aliquota_iss
      }

      return payload
    }

    return {
      ...rest,
      iss_retido,
      aliquota_iss,
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (cpfCnpj?.error) {
      return dispatch({
        type: SNACKBAR.HARDFAIL,
        error: {
          message: 'CNPJ Inválido',
        },
      })
    }

    try {
      const resp = await axios.post(
        `${config.API_URL}/attendance/nfse/${id}`,
        buildPayload()
      )

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: {
          message: 'NFSe gerada com sucesso, aguarde o processamento!',
        },
      })

      dispatch(fetchAttendanceInit())
    } catch (e) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: {
          message: e?.response?.data?.error,
        },
      })
    }
  }

  const fetchEnquadramentos = async national => {
    try {
      const resp = national
        ? await indexNfsenEnquadramento()
        : await indexNfseEnquadramento()

      setEnquadramentos(resp?.data || [])
    } catch (e) {
      console.log(e)
    }
  }

  const handleEnquadramentoSaved = async resp => {
    const created = resp?.data ?? resp

    await fetchEnquadramentos(isNational)

    if (created?.id) {
      setForm(prev => ({
        ...prev,
        enquadramento_id: created.id,
        aliquota_iss:
          created?.aliquota_iss != null ? String(created.aliquota_iss) : '',
      }))
    }
  }

  const enquadramentoFields = isNational
    ? NFSEN_ENQUADRAMENTO_FIELDS
    : NFSE_ENQUADRAMENTO_FIELDS

  const handleVerifyNfseError = async () => {
    setLoading(true)
    try {
      const resp = await axios.get(
        `${config.API_URL}/eletronic-invoice/nfse/${attendance?.id_laundry_client}`
      )

      setNfseError(resp?.data?.data?.erros[0]?.mensagem)
    } catch (e) {
      setLoading(false)

      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: {
          message: e?.response?.data?.message,
        },
      })
    }

    setLoading(false)
  }

  useEffect(() => {
    if (!id) return

    fetchAttedance()
    dispatch(getNfseCompanies())
    show().then(resp => {
      const national = !!resp?.eletronic_invoice_national
      setIsNational(national)
      fetchEnquadramentos(national)
    })
  }, [])

  useEffect(() => {
    if (attendance) {
      if (attendance?.nfse_status_id) {
        handleVerifyNfseError()
      }

      handleInitDescription()
    }
  }, [attendance])

  return (
    <BaseCreatePage page="Atendimentos" path="Gerar NFSe" hiddenReturn goBack>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.subTitle}>
            Complete os campos para gerar NFSe do serviço
          </Box>
        </Grid>

        <Forms.errorBanner loading={loading} nfseError={nfseError} />

        <Grid item xs={12}>
          <form onSubmit={handleSubmit}>
            <Forms.root>
              <Forms.takerData
                nfseCompanies={nfseCompanies}
                form={form}
                mask={mask}
                cpfCnpj={cpfCnpj}
                handleChange={handleChange}
                handleChangeCpf={handleChangeCpf}
                handleValidCpfCnpj={handleValidCpfCnpj}
                handlePasteCpf={handlePasteCpf}
              />

              <Forms.addressContact
                form={form}
                handleChange={handleChange}
                handleSearchCep={handleSearchCep}
              />

              <Forms.fiscalData
                form={form}
                mask={mask}
                isNational={isNational}
                enquadramentos={enquadramentos}
                enquadramentoFields={enquadramentoFields}
                setForm={setForm}
                handleChange={handleChange}
                handleEnquadramentoChange={handleEnquadramentoChange}
                onOpenEnquadramentoModal={() => setEnquadramentoModalOpen(true)}
              />

              <Grid
                item
                xs={12}
                container
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <IconButton
                  type="submit"
                  color={colors.primary}
                  variant="contained"
                  className={filterClasses.btnAdd}
                >
                  <Icon path={mdiInvoiceTextCheckOutline} size={1} />
                  Gerar
                </IconButton>
              </Grid>
            </Forms.root>
          </form>
        </Grid>
      </Grid>

      <EnquadramentoFormModal
        open={enquadramentoModalOpen}
        onClose={() => setEnquadramentoModalOpen(false)}
        fields={
          isNational ? NFSEN_ENQUADRAMENTO_FIELDS : NFSE_ENQUADRAMENTO_FIELDS
        }
        storeFn={isNational ? storeNfsenEnquadramento : storeNfseEnquadramento}
        onSaved={handleEnquadramentoSaved}
      />
    </BaseCreatePage>
  )
}

export default EletronicInvoice
